import { useState } from "react";
import { useIntl } from "react-intl";
import {
  PaymentMethod,
  PaymentMethodNavConst,
} from "../../../../../constants/DepositNavConst";
import { toAbsoluteUrl } from "../../../../../utils/CommonHelper";
import { HistoryAtm } from "./HistoryAtm";
import { HistoryPaymentGateway } from "./HistoryPaymentGateway";
import { HistoryTelco } from "./HistoryTelco";

export const DepositHistory = () => {
  const intl = useIntl();
  const [paymentMethod, setPaymentMethod] = useState(PaymentMethod.ATM);

  return (
    <>
      <div
        className="d-flex mb-3 custom-border-bottom pb-3"
        style={{ width: "95%", margin: "0 auto" }}
      >
        {PaymentMethodNavConst.map((nav, index) => (
          <div key={nav.title} className="card cursor-pointer me-4">
            <div
              style={{
                background: paymentMethod === nav.title ? "#f5be09" : "#2e323a",
                display: "flex",
                width: "80px",
                height: "80px",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px",
                borderRadius: "5px",
              }}
              onClick={() => {
                setPaymentMethod(nav.title);
              }}
            >
              <div
                className={`d-flex flex-column align-items-center menu-item `}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={toAbsoluteUrl(nav.image)}
                    alt="Image Alt Text"
                    style={{
                      width: "30px",
                      height: "30px",
                      filter:
                        paymentMethod === nav.title
                          ? "brightness(0%)"
                          : "brightness(100%)",
                    }}
                  />
                </span>
                <div
                  style={{
                    color: paymentMethod === nav.title ? "black" : "white",
                    textAlign: "center",
                  }}
                  className="text-font2"
                >
                  {intl.formatMessage({ id: nav.title })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ width: "95%", margin: "0 auto" }}>
        {paymentMethod === PaymentMethod.ATM ? (
          <HistoryAtm />
        ) : paymentMethod === PaymentMethod.PAYMENT_GATEWAY ? (
          <HistoryPaymentGateway />
        ) : (
          <HistoryTelco />
        )}
      </div>
    </>
  );
};
